import React, { createContext, useContext } from 'react';
import authStore from './AuthStore';
import themeStore from './ThemeStore';

const StoreContext = createContext({ authStore, themeStore });

export function StoreProvider({ children }) {
  return (
    <StoreContext.Provider value={{ authStore, themeStore }}>
      {children}
    </StoreContext.Provider>
  );
}

export function useStores() {
  return useContext(StoreContext);
}

export function useAuthStore() {
  const { authStore } = useContext(StoreContext);
  return authStore;
}

export function useThemeStore() {
  const { themeStore } = useContext(StoreContext);
  return themeStore;
}
